module.exports = __webpack_public_path__ + "img/feature.ddca705.svg";